import {
  MOTORCYCLE_LIST_FILTER_START,
  MOTORCYCLE_LIST_FILTER_SUCCESS,
  MOTORCYCLE_LIST_FILTER_ERROR,
  MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_START,
  MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_SUCCESS,
  MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_ERROR,
  MULTI_MOTORCYCLE_DELETE_START,
  MULTI_MOTORCYCLE_DELETE_SUCCESS,
  MULTI_MOTORCYCLE_DELETE_ERROR,
  ALL_MOTORCYCLE_LIST_FILTER_SUCCESS,
  CA_MOTORCYCLE_LIST_FILTER_SUCCESS,
  REB_MOTORCYCLE_LIST_FILTER_SUCCESS,
  EB_MOTORCYCLE_LIST_FILTER_SUCCESS,
  UM_MOTORCYCLE_LIST_FILTER_SUCCESS,
  UV_MOTORCYCLE_LIST_FILTER_SUCCESS,
  ALL_RIDER_FILTER_SUCCESS,
  CURRENTLY_RIDER_FILTER_SUCCESS,
  REBOOKING_RIDER_FILTER_SUCCESS,
  EXTERNAL_RIDER_FILTER_SUCCESS,
  MAINTANCE_RIDER_FILTER_SUCCESS,
  UNDER_VERIFICATION_RIDER_FILTER_SUCCESS,
  CLEAR_ALL_DATA,
  ALL_RIDER_FILTER_DOWNLOAD_SUCCESS,
} from "Constant";

const initialState = {
  loading: false,
  motorcycleListWithFilter: [],
  deleteData: [],
  markAsAvailableData: [],
  allMotorcyclesData: [],
  caMotorcyclesData: [],
  rebMotorcyclesData: [],
  ebMotorcyclesData: [],
  umMotorcyclesData: [],
  uvMotorcyclesData: [],
  allMotorcyclesFilterData: [],
  caMotorcyclesFilterData: [],
  rebMotorcyclesFilterData: [],
  ebMotorcyclesFilterData: [],
  umMotorcyclesFilterData: [],
  uvMotorcyclesFilterData: [],
};

export default function pincodeReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case MOTORCYCLE_LIST_FILTER_START:
      return {
        ...state,
        loading: true,
      };
    case MOTORCYCLE_LIST_FILTER_SUCCESS:
      return {
        ...state,
        motorcycleListWithFilter: action.payload,
        loading: false,
      };
    case MOTORCYCLE_LIST_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_START:
      return {
        ...state,
        loading: true,
      };
    case MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_SUCCESS:
      return {
        ...state,
        markAsAvailableData: action.payload,
        loading: false,
      };
    case MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case MULTI_MOTORCYCLE_DELETE_START:
      return {
        ...state,
        loading: true,
      };
    case MULTI_MOTORCYCLE_DELETE_SUCCESS:
      return {
        ...state,
        deleteData: action.payload,
        loading: false,
      };
    case MULTI_MOTORCYCLE_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case ALL_MOTORCYCLE_LIST_FILTER_SUCCESS:
      return {
        ...state,
        allMotorcyclesData: action.payload,
        loading: false,
      };
    case CA_MOTORCYCLE_LIST_FILTER_SUCCESS:
      return {
        ...state,
        caMotorcyclesData: action.payload,
        loading: false,
      };
    case REB_MOTORCYCLE_LIST_FILTER_SUCCESS:
      return {
        ...state,
        rebMotorcyclesData: action.payload,
        loading: false,
      };
    case EB_MOTORCYCLE_LIST_FILTER_SUCCESS:
      return {
        ...state,
        ebMotorcyclesData: action.payload,
        loading: false,
      };
    case UM_MOTORCYCLE_LIST_FILTER_SUCCESS:
      return {
        ...state,
        umMotorcyclesData: action.payload,
        loading: false,
      };
    case UV_MOTORCYCLE_LIST_FILTER_SUCCESS:
      return {
        ...state,
        uvMotorcyclesData: action.payload,
        loading: false,
      };
    case ALL_RIDER_FILTER_SUCCESS:
      return {
        ...state,
        allMotorcyclesFilterData: action.payload,
        loading: false,
      };
    case CURRENTLY_RIDER_FILTER_SUCCESS:
      return {
        ...state,
        caMotorcyclesFilterData: action.payload,
        loading: false,
      };
    case REBOOKING_RIDER_FILTER_SUCCESS:
      return {
        ...state,
        rebMotorcyclesFilterData: action.payload,
        loading: false,
      };
    case EXTERNAL_RIDER_FILTER_SUCCESS:
      return {
        ...state,
        ebMotorcyclesFilterData: action.payload,
        loading: false,
      };
    case MAINTANCE_RIDER_FILTER_SUCCESS:
      return {
        ...state,
        umMotorcyclesFilterData: action.payload,
        loading: false,
      };
    case UNDER_VERIFICATION_RIDER_FILTER_SUCCESS:
      return {
        ...state,
        uvMotorcyclesFilterData: action.payload,
        loading: false,
      };
    case ALL_RIDER_FILTER_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_ALL_DATA:
      return {
        ...state,
        motorcycleListWithFilter: [],
        deleteData: [],
        markAsAvailableData: [],
        allMotorcyclesData: [],
        caMotorcyclesData: [],
        rebMotorcyclesData: [],
        ebMotorcyclesData: [],
        umMotorcyclesData: [],
        uvMotorcyclesData: [],
        allMotorcyclesFilterData: [],
        caMotorcyclesFilterData: [],
        rebMotorcyclesFilterData: [],
        ebMotorcyclesFilterData: [],
        umMotorcyclesFilterData: [],
        uvMotorcyclesFilterData: [],
      };
    default:
      return state;
  }
}
